import React from 'react';

export const ProgressBar = ({ progress }) => {
  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 h-1.5 bg-slate-200"
      data-testid="progress-bar"
    >
      <div 
        className="h-full bg-gradient-to-r from-gold-400 to-gold-500 transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
      {/* Glow effect at the end */}
      <div 
        className="absolute top-0 h-full w-8 bg-gradient-to-r from-transparent to-gold-400/30 blur-sm transition-all duration-500"
        style={{ left: `calc(${progress}% - 2rem)` }}
      />
    </div>
  );
};
